import jwtDecode from 'jwt-decode'

export const LOCAL_STORAGE_TOKEN_KEY = 'reggora_auth_token'

export const tokenService = {
  getToken: () => {
    return localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY)
  },

  getTokenAsync: async () => {
    return localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY)
  },

  setToken: (token) => {
    localStorage.setItem(LOCAL_STORAGE_TOKEN_KEY, token)
  },

  removeToken: () => {
    localStorage.removeItem(LOCAL_STORAGE_TOKEN_KEY)
  },

  isTokenValid: (token) => {
    if (!token) { return false }

    try {
      const decoded = jwtDecode(token)
      const now = new Date()
      const expirationDate = typeof decoded.exp === 'number'
        ? new Date(decoded.exp * 1000)
        : new Date(Date.parse(decoded.exp))

      return !decoded.error && now < expirationDate
    } catch (err) {
      return false
    }
  },
}

export const tokenUtils = {
  getUserIDFromToken: (token) => {
    try {
      const decodedValue = jwtDecode(token)
      return decodedValue?.user_id
    } catch (err) {
      return undefined
    }
  },
}

// Named convenience exports for direct imports
export const { getToken, getTokenAsync, setToken, removeToken, isTokenValid } = tokenService
export const { getUserIDFromToken } = tokenUtils
